// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB-KmRHHIf5i4rKj4obPTUrq6P156YBQnU",
  authDomain: "sociohood-253f6.firebaseapp.com",
  projectId: "sociohood-253f6",
  storageBucket: "sociohood-253f6.firebasestorage.app",
  messagingSenderId: "36909446323",
  appId: "1:36909446323:web:6a55a079bea6abd5e76cc6",
  measurementId: "G-GQ44S5FTGG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;

